export const api = 'https://www.slfangshuijiao.com/api';
export const deptId = 112;